import { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import errorHandler from 'src/utils/error-handler';
import http from 'src/services/httpService';
import SearchBar from 'src/componentes/filtro/search-drawer/SearchBar';
import ResumoSection from 'src/paginas/colaborador/componentes/search-sections/ResumoSection';
import PessoalSection from 'src/paginas/colaborador/componentes/search-sections/PessoalSection';
import FormacaoSection from 'src/paginas/colaborador/componentes/search-sections/FormacaoSection';
import IdiomasSection from 'src/paginas/colaborador/componentes/search-sections/IdiomasSection';
import ExperienciasSection from 'src/paginas/colaborador/componentes/search-sections/ExperienciasSection';
import ExtracurricularesSection from 'src/paginas/colaborador/componentes/search-sections/ExtracurricularesSection';
import DivulgacaoAniversarioSection from 'src/paginas/colaborador/componentes/search-sections/DivulgacaoAniversarioSection';
import InteresseOutrasAreasSection from 'src/paginas/colaborador/componentes/search-sections/InteresseOutrasAreasSection';
import DisponibilidadeMudancasSection from 'src/paginas/colaborador/componentes/search-sections/DisponibilidadeMudancasSection';
import CustomFieldsSection from 'src/componentes/filtro/search-drawer/CustomFieldsSection';

const ColaboradorSearch = ({ model, resources, intl }) => {
  const [campos, setCampos] = useState({});
  const [searchQuery, setSearchQuery] = useState('');

  const getCampos = async () => {
    try {
      const response = await http.post(
        '/ColaboradorConfiguracao/ObterConfiguracoes'
      );
      const camposArray = response.data.campos;
      setCampos(
        Object.fromEntries(
          camposArray.map((campo) => [campo.campoId, campo.visivel])
        )
      );
    } catch (err) {
      errorHandler(err);
    }
  };

  useEffect(() => {
    getCampos();
  }, []);

  return (
    <>
      <SearchBar
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />

      <ResumoSection
        model={model}
        resources={resources}
        intl={intl}
        searchQuery={searchQuery}
      />

      <PessoalSection
        model={model}
        intl={intl}
        campos={campos}
        searchQuery={searchQuery}
      />

      <FormacaoSection
        model={model}
        intl={intl}
        campos={campos}
        searchQuery={searchQuery}
      />

      <IdiomasSection
        model={model}
        intl={intl}
        campos={campos}
        searchQuery={searchQuery}
      />

      <ExperienciasSection
        model={model}
        resources={resources}
        intl={intl}
        campos={campos}
        searchQuery={searchQuery}
      />

      <ExtracurricularesSection
        model={model}
        resources={resources}
        intl={intl}
        campos={campos}
        searchQuery={searchQuery}
      />

      <DivulgacaoAniversarioSection
        model={model}
        intl={intl}
        campos={campos}
        searchQuery={searchQuery}
      />

      <InteresseOutrasAreasSection
        model={model}
        resources={resources}
        intl={intl}
        campos={campos}
        searchQuery={searchQuery}
      />

      <DisponibilidadeMudancasSection
        model={model}
        intl={intl}
        campos={campos}
        searchQuery={searchQuery}
      />
      <CustomFieldsSection
        model={model}
        intl={intl}
        searchQuery={searchQuery}
      />
    </>
  );
};

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}

export default injectIntl(connect(mapStateToProps)(ColaboradorSearch));
